
import { PaginaCustomEnum } from "@/components/utils";
import Vue from "vue";
import Component from "vue-class-component";
import { namespace } from "vuex-class";
import ContatoCustomView from "./CustomPages/Contato.vue";
import PaginaBrancoCustomView from "./CustomPages/Branco.vue";
import QuemSomosCustomView from "./CustomPages/QuemSomos.vue";
import SimpleBreadcrumbs from "@/components/SimpleBreadcrumbs.vue";
import { updateTitle } from "@/utils/titleUpdater";

const AppConfigStore = namespace("AppConfig");

@Component({
  components: {
    SimpleBreadcrumbs,
  },
  props: {
    name: {
      default: null,
    },
  },
})
export default class CustomPageView extends Vue {
  @AppConfigStore.Getter
  private getListaPaginasCustom!: any;

  @AppConfigStore.Getter
  private getConfigsVisuais!: any;

  pageData = {};

  get getActivePageData() {
    if (!this.pageData) {
      return null;
    }
    return this.pageData;
  }

  tipoPaginaMap = {
    [PaginaCustomEnum.BRANCO]: PaginaBrancoCustomView,
    [PaginaCustomEnum.CONTATO]: ContatoCustomView,
    [PaginaCustomEnum.EMPRESA]: QuemSomosCustomView,
  };

  get activeCustomPage() {
    const activePage = this.getListaPaginasCustom?.find(
      (el) => el.nome.replaceAll(" ", "_").toLowerCase() === this.$props.name
    );
    if (!activePage) return null;

    this.pageData = activePage;

    updateTitle(activePage.nome);
    return this.tipoPaginaMap[activePage.tipoPagina] || null;
  }
}
